import { render, staticRenderFns } from "./AdditionalTabFormBody.vue?vue&type=template&id=09c21d0c&scoped=true"
import script from "./AdditionalTabFormBody.vue?vue&type=script&lang=js"
export * from "./AdditionalTabFormBody.vue?vue&type=script&lang=js"
import style0 from "./AdditionalTabFormBody.vue?vue&type=style&index=0&id=09c21d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c21d0c",
  null
  
)

export default component.exports